/** @format */

import {SpaceId, SpaceList} from 'pages/Home/DigitalCast/models/spaces';

import {SavedDashboardsList} from 'pages/Home/DigitalCast/models/savedSpaceSettings';

import mapSavedSpace from './mapSavedSpace';

/**
 * Добавит дашборд в список дашбордов перед сохранением на сервер
 * @param spacesToMap
 */

const mapSavedSpaces = (spacesToMap: SpaceList): SavedDashboardsList => {
  const allOriginalSpaceIds = Object.keys(spacesToMap) as SpaceId[];
  const result: SavedDashboardsList = {};

  allOriginalSpaceIds.forEach(id => {
    result[id] = mapSavedSpace(spacesToMap[id]);
  });

  return result;
};

export default mapSavedSpaces;
